import React, { useEffect, useState } from 'react';
import WhatsAppButton from '@/components/ui/WhatsAppButton';

/**
 * Fixed WhatsApp CTA shown on mobile. Hides itself when the user is near
 * the top of the page (Hero/calculator already shows a primary CTA), and
 * reappears as soon as they scroll past it. Avoids competing with the
 * in-hero CTA above the fold.
 */
const MobileWhatsAppCTA: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show after the user scrolls past ~70% of the first viewport
      const threshold = Math.max(400, window.innerHeight * 0.7);
      setVisible(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-gradient-to-t from-background via-background to-transparent animate-in slide-in-from-bottom-4 fade-in duration-300">
      <WhatsAppButton
        text="Falar com especialista"
        source="mobile_cta"
        variant="whatsapp"
        size="lg"
        fullWidth={true}
        showIcon={true}
        className="min-h-[56px] text-base font-semibold shadow-lg hover:shadow-xl transition-all"
      />
    </div>
  );
};

export default MobileWhatsAppCTA;
